<template>
  <v-app dark>
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      clipped
      v-model="drawer"
      enable-resize-watcher
      fixed
      app>
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :to="item.url"
          :key="i">
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-toolbar-title v-text="title"></v-toolbar-title>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span class="ml-2">BeCAMe &copy; 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        drawer: true,
        fixed: false,
        items: [
          {
            icon: 'share',
            title: 'Shared content',
            url: 'shared',
          },
          {
            icon: 'far fa-lightbulb',
            title: 'Ideas',
            url: 'ideas',
          },
          {
            icon: 'far fa-user',
            title: 'Contacts',
            url: 'contacts',
          },
        ],
        miniVariant: false,
        title: 'BeCAMe\'s Back Office',
      };
    },
    name: 'App',
  };
</script>



// WEBPACK FOOTER //
// src/App.vue